import React, { useEffect, useRef, useState } from 'react';
import { Button, Divider, Input, Typography } from 'antd';
import { useVerifyMfa } from '../../../../hooks/useAuth';
import { AuthLayout } from '../../components/Layout';

export const PageMFAVerify = () => {
    const [mfaToken, setMfaToken] = useState('');
    const inputRef = useRef(null);
    const verify = useVerifyMfa();

    useEffect(() => {
        inputRef.current?.focus();
    }, []);

    const submit = (token) => verify.mutate({ token });

    const onMFATokenChange = (e) => {
        const digitsOnly = e.target.value.replace(/\D/g, '');
        setMfaToken(digitsOnly);
        if (digitsOnly.length === 6) submit(digitsOnly);
    };

    return (
        <AuthLayout
            error={verify.error}
            heading='Two-factor verification'
            subheading='Enter the 6-digit code from your authenticator app.'
        >
            <Typography.Title level={4}>Two-Factor Authentication (2FA)</Typography.Title>
            <Divider />
            <div>Open the two-step verification app on your mobile device to get your verification code.</div>
            <Divider />
            <Input
                ref={inputRef}
                value={mfaToken}
                onChange={onMFATokenChange}
                placeholder='Enter code (XXXXXX)'
                maxLength={6}
                inputMode='numeric'
                autoComplete='one-time-code'
            />
            <Divider />
            <Button
                onClick={() => submit(mfaToken)}
                size='large'
                type='primary'
                htmlType='submit'
                loading={verify.isPending}
                className='login-form-button'
            >
                Authenticate
            </Button>
        </AuthLayout>
    );
};
